import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import ProductVariationOption from "./ProductVariationOption";
import Image from "../library/Image";
import StoreDomainVariationMapping from "./StoreDomainVariationMapping";
import Model from "./Model";
export default class ProductVariation extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Id", {
      fieldName: 'id',
      content: null
    });
    _defineProperty(this, "Image", {
      fieldName: 'image',
      model: Image,
      content: null
    });
    _defineProperty(this, "Options", {
      fieldName: 'options',
      model: ProductVariationOption,
      content: []
    });
    _defineProperty(this, "Sku", {
      fieldName: 'sku',
      content: null
    });
    /*    Quantity = {
            fieldName: 'quantity',
            content: 1
        }
        UnitPrice = {
            fieldName: 'unit_price',
            content: 0
        }*/
    _defineProperty(this, "Status", {
      fieldName: 'status',
      content: ProductVariation.INACTIVE_STATUS
    });
    _defineProperty(this, "wcProductVariationMapping", {
      fieldName: 'wc_product_variation_mapping',
      model: StoreDomainVariationMapping,
      content: null
    });
  }
  getId() {
    return this.Id.content;
  }
  getOptions() {
    return this.Options.content;
  }
  getImage() {
    return this.Image.content;
  }
  getImageUrl() {
    let image = this.getImage();
    return image instanceof Image ? image.getUrl() : null;
  }
  getSku() {
    return this.Sku.content;
  }
  getWcProductMapping() {
    return this.wcProductVariationMapping.content;
  }
  getWcProductMappingCustomId() {
    let wcVariationMapping = this.getWcProductMapping();
    return wcVariationMapping instanceof StoreDomainVariationMapping ? wcVariationMapping.getCustomVariationId() : null;
  }
}
_defineProperty(ProductVariation, "ACTIVE_STATUS", 'active');
_defineProperty(ProductVariation, "INACTIVE_STATUS", 'inactive');
_defineProperty(ProductVariation, "DELETED_STATUS", 'deleted');